function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
export { _classCallCheck as default };


//////////////////
// WEBPACK FOOTER
// ./~/i18next/~/@babel/runtime/helpers/esm/classCallCheck.js
// module id = 3352
// module chunks = 0